// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchInput_wrapper__LBPYK","input":"SearchInput_input__seByF","label":"SearchInput_label__8VJxT"};